"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const uris_1 = require("../globals/uris");
const control_1 = require("../model/control");
/**
 * Autocontrols that use statistics to set their values.
 * @abstract
 */
class AutoControl extends control_1.Control {
    constructor(uri, name, store) {
        super(uri, name, uris_1.AUTO_CONTROL, store);
        this.init();
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            this.intervalID = null;
            this.frequency = yield this.store.findControlParamValue(this.uri, uris_1.AUTO_CONTROL_FREQUENCY);
            if (!this.frequency)
                this.frequency = 100;
            const freqUri = yield this.store.setControlParam(this.uri, uris_1.AUTO_CONTROL_FREQUENCY, this.frequency);
            this.store.addValueObserver(freqUri, uris_1.VALUE, this);
            const triggUri = yield this.store.setControlParam(this.uri, uris_1.AUTO_CONTROL_TRIGGER, 0);
            this.store.addValueObserver(triggUri, uris_1.VALUE, this);
            //CANNOT START UPDATE HERE! NEEDS TO BE STARTED FROM UI! this.startUpdate();
        });
    }
    startUpdate(newFrequency) {
        if (this.intervalID) {
            this.reset();
        }
        if (newFrequency) {
            this.frequency = newFrequency;
        }
        this.update();
        this.intervalID = setInterval(() => this.update(), this.frequency);
    }
    reset() {
        clearInterval(this.intervalID);
        this.intervalID = null;
    }
    observedValueChanged(paramUri, paramType, value) {
        if (paramType == uris_1.AUTO_CONTROL_FREQUENCY) {
            this.frequency = value;
            //restart with new frequency if already running
            if (this.intervalID) {
                this.startUpdate(value);
            }
        }
        else if (paramType == uris_1.AUTO_CONTROL_TRIGGER) {
            if (!this.intervalID && value > 0) {
                this.startUpdate();
            }
            else if (this.intervalID && value == 0) {
                this.reset();
            }
        }
    }
}
exports.AutoControl = AutoControl;



//////////////////
// WEBPACK FOOTER
// ./~/dymo-core/lib/controls/autocontrol.js
// module id = 269
// module chunks = 3